mutation PurchaseOrderApprovalRevoke(
  $input: PurchaseOrderApprovalRevokeInput!
) {
  purchaseOrderApprovalRevoke(input: $input) {
    revokedApprovalEntity
  }
}
